import { render, staticRenderFns } from "./xmyNotReached.vue?vue&type=template&id=70fa1223&scoped=true"
import script from "./xmyNotReached.vue?vue&type=script&lang=js"
export * from "./xmyNotReached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa1223",
  null
  
)

export default component.exports